import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ActionsService {
  private readonly pendingActionsList = new BehaviorSubject<any>(null);
  private readonly renewalActionsList = new BehaviorSubject<any>(null);
  private readonly transferActionsList = new BehaviorSubject<any>(null);
  private readonly deprovisioningActionsList = new BehaviorSubject<any>(null);
  private readonly historyActionsList = new BehaviorSubject<any>(null);

  constructor(private readonly http: HttpClient, private readonly auth: AuthService) {}

  getRenewalActionList() {
    return this.renewalActionsList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getTransferActionList() {
    return this.transferActionsList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getDeprovisioningActionList() {
    return this.deprovisioningActionsList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getPendingActionList() {
    return this.pendingActionsList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getHistoryActionList() {
    return this.historyActionsList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getAllPendingActions() {
    let url = `${environment.baseUrl}/actions/pending`;
    this.http.get(url).subscribe((pending) => {
      this.pendingActionsList.next(pending);
    });
  }

  getAllRenewalsActions() {
    let url = `${environment.baseUrl}/actions/pending/renew`;
    this.http.get(url).subscribe((renewal) => {
      this.renewalActionsList.next(renewal);
    });
  }

  getAllTransfersActions() {
    let url = `${environment.baseUrl}/actions/pending/transfer`;
    this.http.get(url).subscribe((transfer) => {
      this.transferActionsList.next(transfer);
    });
  }

  getAllDeprovisioningsActions() {
    let url = `${environment.baseUrl}/actions/pending/deprovisioning`;
    this.http.get(url).subscribe((deprovisioning) => {
      this.deprovisioningActionsList.next(deprovisioning);
    });
  }

  getAllHistoryActions(nextPageToken?: string): Observable<HttpResponse<any>> {
    const paramNextPage = nextPageToken
      ? `&nextPageToken=${nextPageToken}`
      : '';
    let url = `${environment.baseUrl}/actions/history?listSize=10${paramNextPage}`;
    return this.http.get<any>(url);
  }

  getPendingAction(actionId: string) {
    let url = `${environment.baseUrl}/actions/${actionId}`;
    return this.http.get(url);
  }

  approveAction(actionId: string, message: string) {
    let url = `${environment.baseUrl}/actions/${actionId}/approve`;
    let currentUser: any = this.auth.getCurrentUserInfo();
    return this.http.put(url, {
      name: currentUser.given_name + ' ' + currentUser.family_name,
      label: message,
    });
  }

  rejectAction(actionId: string, message: string) {
    let url = `${environment.baseUrl}/actions/${actionId}/reject`;
    let currentUser: any = this.auth.getCurrentUserInfo();
    return this.http.put(url, {
      name: currentUser.given_name + ' ' + currentUser.family_name,
      label: message,
    });
  }

  completeAction(actionId: string, formData: any) {
    let url = `${environment.baseUrl}/actions/${actionId}/complete`;
    return this.http.put(url, formData);
  }

  approveActions(actionIds: string[]) {
    let url = `${environment.baseUrl}/actions/bulk/approve`;
    return this.http.put(url, actionIds);
  }

  rejectActions(actionIds: string[]) {
    let url = `${environment.baseUrl}/actions/bulk/reject`;
    return this.http.put(url, actionIds);
  }
}
